/**
 * Created by mykurisu on 2017/12/25.
 */
import React from 'react'
import {connect} from 'react-redux'
import axios from 'axios'
import {Toast, Button} from 'react-weui'
import { sharePic } from '../../../utils/connectApp'
import { isLZWKAPP } from '../../../utils'
import handImg from '../../../images/activity/giftcard/hand.png'
import bottomImg from '../../../images/activity/giftcard/bottom-money.png'


class GiftCardDetail extends React.Component {

    constructor() {
        super();
        this.state = {
            sharecard: '',
            toastShow: false
        }
    }

    componentDidMount() {
        document.title = '送心意，赚奖励';

        const {query} = this.props.location;
        this.setState({
            toastShow: true
        });
        axios.get(`/api/coupon/weike_active/${query.bagid}/sharecard/rp_info`,{
            params: {
                bag_id: query.bagid,
                template_id: query.template_id,
                greettext: decodeURIComponent(query.greettext),
                from: query.from
            }
        }).then(res => {
            if (res.data.code === 0){
                this.setState({
                    toastShow: false,
                    sharecard: res.data.data.sharecard
                });

                let share_info = res.data.data.share_info;
                this.props.dispatch({
                    type: 'UPDATE_SHARE_DATA',
                    payload: {
                        title: share_info.share_title,
                        desc: share_info.share_description,
                        imgUrl: share_info.share_icon,
                        link: share_info.share_url,
                        is_resell: '1'
                    }
                });
            }
        })
    }

    onClickAppShare () {
        sharePic({ pic: this.state.sharecard.card_url })
    }

    render() {
        return (
            <div className="giftcard__detail">
                <Toast show={this.state.toastShow} icon="loading">生成中</Toast>
                <div className="detail__img">
                    <img src={this.state.sharecard.card_url} alt=""/>
                </div>
                {
                    isLZWKAPP() && (
                        <Button className='app-share-btn' onClick={e => this.onClickAppShare()}>分享给好友 赚3元现金</Button>
                    )
                }
                {
                    !isLZWKAPP() && (
                        <div className="detail__text">
                            <div className="text">
                                <p>你的祝福已放进红包</p>
                                <p>长按上图“发送给好友”</p>
                            </div>
                            <div className="hand">
                                <img src={handImg} alt=""/>
                            </div>
                        </div>
                    )
                }

                {
                    !isLZWKAPP() && (
                        <div className="bottom">
                            <img src={bottomImg} alt=""/>
                        </div>
                    )
                }
                
            </div>
        )
    }

}

export default connect(state => ({}))(GiftCardDetail)



// WEBPACK FOOTER //
// ./src/pages/ActivityPage/GiftCard/GiftCardDetail.js